module.exports = __webpack_public_path__ + "img/senior-account.a3b0381.svg";